import React        from 'react';
import connectField from 'uniforms/connectField';
import joinName     from 'uniforms/joinName';
import {Children}   from 'react';

import { AutoField } from 'uniforms-bootstrap3';
import ListDelField from './ListDelField';

import {
  FormControl,
  Col,
  Button,
  Table
} from '@sketchpixy/rubix';

const ListItem = ({removeIcon, ...props}) =>
    <Col sm={12}>
        <Col sm={2}>
            <ListDelField name={props.name} removeIcon={removeIcon} />
        </Col>

        <Col sm={10}>
        <Table><tbody>
        {props.children ? (
            Children.map(props.children, child =>
                React.cloneElement(child, {
                    className: 'col-xs-11',
                    name: joinName(props.name, child.props.name),
                    label: null
                })
            )
        ) : (
            <tr><td><AutoField {...props} /></td></tr>
        )}
        </tbody></Table>
        </Col>
    </Col>;


export default connectField(ListItem, {includeInChain: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/ListItemField.js
 **/